import { Link, useLocation } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <div className="mx-auto flex max-w-page flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-5xl text-primary-600">
          <i className="ri-compass-3-line"></i>
        </span>
        <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-500">
          抱歉，你访问的页面不存在或已被移除。
        </p>
        <p className="mt-1 font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            去搜索热点
          </Link>
        </div>
      </div>
    </Layout>
  );
}